import { css } from 'lit';

export const tutorialIndexViewStyles = css`

  view-content {
    padding-top: 4rem;
  }

  header-bar {
    --header-icon-color: var(--gray-4);
    --header-icon-opacity: 0.2;
    --header-icon-bottom-position: -3.5rem;
  }

  table.q1 {
    margin: var(--view-item-spacing) 0;
  }

  table.q1 tr:not(.completed) td {
    --table-td-bg-color: var(--yellow-1);
  }
  table.q1 tr:not(.completed) td.icon-col sl-icon {
    animation: pulse-color 3s infinite;
  }

  @keyframes pulse-color {
    0%, 50%, 100% {
      color: var(--teal-6); /* Default color */
      transform: scale(1);
    }
    70% {
      color: var(--teal-2); /* Pulsed color */
      transform: scale(1.2);
    }
  }

  table.q1 td.icon-col {
    width: 1rem;
    font-size: 1.1rem;
    line-height: 1em;
    padding-right: 0;
  }
  table.q1 tr.completed td.icon-col {
    color: var(--green-6);
  }
  table.q1 tr.updated td.icon-col {
    color: var(--yellow-6);
  }
  table.q1 td.title-col {
    color: var(--gray-5);
    --link-color-default: var(--gray-8);
    --link-text-decoration-default: none;
    --link-color-visited: var(--gray-7);
    --link-color-focus: var(--gray-9);
    --link-font-weight-default: 500;
  }
  table.q1 tr.completed td.title-col {
    --link-color-default: var(--green-7);
    --link-text-decoration-default: none;
    --link-color-visited: var(--green-7);
    --link-color-focus: var(--green-8);
    --link-font-weight-default: normal;
    font-style: italic;
  }
  table.q1 td.title-col a {
    text-wrap: wrap;
  }
  table.q1 td.title-col .divider {
    display: none;
  }
  table.q1 td.title-col sl-icon {
    margin-left: 0.5rem;
  }
  table.q1 td.title-col .duration {
    flex: 1 1 auto;
  }
  @media(min-width: 650px) {
    table.q1 td.title-col .divider {
      display: inline-block;
    }
    table.q1 td.title-col sl-icon {
      margin-left: 0;
    }
  }

  table.q1 td.version-col {
    width: 5rem;
    font-style: italic;
    display: none;
  }
  @media(min-width: 500px) {
    table.q1 td.version-col {
      display: table-cell;
    }
  }

  table.q1 td.action-col {
    width: 3rem;
    display: none;
  }
  @media(min-width: 650px) {
    table.q1 td.action-col {
      display: table-cell;
    }
  }

  table.q1 td .td-inner {
    display: flex;
    gap: 0.25rem;
    align-items: center;
    justify-content: flex-start;
  }

  table.q1 td .light {
    color: var(--gray-5);
  }

`;
